import "./BatchProgressBar.css";

interface ErrorLog {
  file: string;
  message: string;
}

interface BatchProgressBarProps {
  progress?: number;
  processed?: number;
  total?: number;
  currentFile?: string;
  errors?: ErrorLog[];
}

const BatchProgressBar: React.FC<BatchProgressBarProps> = ({
  progress = 0,
  processed = 0,
  total = 0,
  currentFile = "",
  errors = [],
}) => (
  <div className="batch-progress-container">
    <div className="progress-bar-header">
      <span>Analysis progress</span>
      <span className="progress-perc"><span className="notranslate">{progress}</span>%</span>
    </div>
    <div className="progress-bar-background">
      <div
        className="progress-bar-foreground"
        style={{ width: `${progress}%` }}
      />
    </div>
    <div className="progress-label">
      <span className="notranslate">{processed}/{total}</span>&nbsp;processed files
      {currentFile && (
        <span className="progress-details">
          &nbsp;|&nbsp;Current file: <strong>{currentFile}</strong>
        </span>
      )}
    </div>
    {/* Section Errori */}
    {errors && errors.length > 0 && (
      <div className="error-log-section">
        <div className="error-section-title">Errors</div>
        <ul className="error-list">
          {errors.map((err, idx) => (
            <li key={idx} className="error-message">
              - {err.file}: {err.message}
            </li>
          ))}
        </ul>
      </div>
    )}
  </div>
);

export default BatchProgressBar;
